import { C as N, u as q } from "./Chatbot2.js";
import { j as t } from "./jsx-runtime.js";
import { p as i } from "./index2.js";
import { I as p } from "./InputBarTrigger2.js";
import { u as G } from "./InputBarTrigger2.js";
import { ModalView as a } from "./ModalView.js";
import { MongoDbLegalDisclosure as m } from "./MongoDbLegal.js";
import { MongoDbLegalDisclosureText as K } from "./MongoDbLegal.js";
import { m as n } from "./ui-text.js";
import { M as Q, d as U } from "./ui-text.js";
import { FloatingActionButtonTrigger as g } from "./FloatingActionButtonTrigger.js";
import { PoweredByAtlasVectorSearch as x } from "./PoweredByAtlasVectorSearch.js";
import { c as u } from "./index3.js";
import { C as Y, R as Z, T as _, u as $ } from "./ConversationProvider.js";
import { useChatbotContext as ot } from "./useChatbotContext.js";
import { ActionButtonTrigger as et } from "./ActionButtonTrigger.js";
import { ChatWindow as it } from "./ChatWindow.js";
import "./UserProvider.js";
import "react";
import "./LinkDataProvider.js";
import "./ChatbotProvider.js";
import "./useLinkData.js";
import "./index4.js";
import "./util.js";
import "./index5.js";
import "./index6.js";
import "./utils.js";
import "./index7.js";
import "react-dom";
import "./index8.js";
import "./index9.js";
function V(o) {
  const { darkMode: r } = i(o.darkMode), e = {
    suggestedPrompts: o.suggestedPrompts ?? [],
    bottomContent: /* @__PURE__ */ t.jsx(m, {})
  }, s = {
    darkMode: r,
    inputBottomText: n
  };
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(p, { ...e }),
    /* @__PURE__ */ t.jsx(a, { ...s })
  ] });
}
function L(o) {
  const { darkMode: r } = i(o.darkMode), e = {}, s = {
    darkMode: r,
    initialMessageText: o.initialMessageText ?? "Hi! I'm the MongoDB AI. What can I help you with today?",
    initialMessageReferences: o.initialMessageReferences,
    initialMessageSuggestedPrompts: o.initialMessageSuggestedPrompts ?? [],
    disclaimer: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(m, {}),
      /* @__PURE__ */ t.jsx(
        x,
        {
          className: u`
            margin-top: 8px;
          `,
          linkStyle: "text"
        }
      )
    ] }),
    inputBottomText: n
  };
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(g, { ...e }),
    /* @__PURE__ */ t.jsx(a, { ...s })
  ] });
}
export {
  et as ActionButtonTrigger,
  it as ChatWindow,
  Y as ConversationService,
  L as DevCenterChatbot,
  V as DocsChatbot,
  g as FloatingActionButtonTrigger,
  p as InputBarTrigger,
  a as ModalView,
  Q as MongoDbInputBarPlaceholder,
  m as MongoDbLegalDisclosure,
  K as MongoDbLegalDisclosureText,
  x as PoweredByAtlasVectorSearch,
  Z as RetriableError,
  _ as TimeoutError,
  N as default,
  U as defaultChatbotFatalErrorMessage,
  n as mongoDbVerifyInformationMessage,
  q as useChatbot,
  ot as useChatbotContext,
  $ as useConversation,
  G as useTextInputTrigger
};
